<template>
	<recent-assignments :take="take" :filters="{ keys: computeFilters }" :per-page="perPage"></recent-assignments>
</template>
<script>
	import { ref, computed, inject, onMounted } from "vue";
	import recentAssignments from "@/components/webComponents/widget/recentAssignments/recentAssignments.vue";
	export default {
		components: {
			recentAssignments
		},
		props: {
			json: {
				type: String,
				default: undefined
			},
			take: {
				type: [String, Number],
				default: 5
			},
			pageFilters: {
				type: String,
				default: "{}"
			},
			perPage: {
				type: Number,
				default: 50
			}
		},
		setup(props, context) {
			const $json = inject("$json");
			const moment = inject("$moment");
			const $http = inject("$http");

			const globalFilters = ref({});
			const filter = ref([]);

			if ($json.packed(props.json)) {
				filter.value = JSON.parse($json.unpack(props.json));
			} else {
				filter.value = JSON.parse(props.json || "[]");
			}

			if ($json.packed(props.pageFilters)) {
				globalFilters.value = JSON.parse($json.unpack(props.pageFilters));
			} else {
				globalFilters.value = JSON.parse(props.pageFilters || "{}");
			}

			const computeFilters = computed(() => {
				if (filter.value.length > 0) {
					return filter.value;
				} else if (globalFilters.value.AssignmentsFilter.length > 0) {
					return globalFilters.value.AssignmentsFilter;
				} else {
					return globalFilters.value.Parent?.AssignmentsFilter || [];
				}
			});

			return {
				computeFilters
			};
		}
	};
</script>
